import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { clearDeleteUserSuccess, deleteUserRequest } from "../../redux/action";
import { toast } from "react-hot-toast";

export const DeleteUserCard = ({ handleClose, userId }) => {
  const dispatch = useDispatch();

  const { deleteUserSuccess, deleteUserError, deleteUserLoading, user, token } =
    useSelector((state) => {
      const {
        success: { deleteUser: deleteUserSuccess },
        errors: { deleteUser: deleteUserError },
      } = state.ajaxStatuses;

      const { deleteUserLoading } = state.loadingIndicator;

      const { user, token } = state.userData;

      return {
        deleteUserSuccess,
        deleteUserError,
        deleteUserLoading,
        user,
        token,
      };
    });

  const deleteUser = () => {
    const id = userId;
    dispatch(deleteUserRequest({ id, token }));
  };

  useEffect(() => {
    if (deleteUserError) {
      toast.error(deleteUserError, {
        duration: 3000,
      });
    }
  }, [deleteUserError]);

  useEffect(() => {
    if (deleteUserSuccess) {
      toast.success(deleteUserSuccess, {
        duration: 3000,
      });
      handleClose();

      dispatch(clearDeleteUserSuccess());
    }
  }, [deleteUserSuccess]);

  return (
    <div className="space-y-4">
      <div className="flex gap-3">
        <button
          onClick={handleClose}
          className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium transition-colors duration-200"
        >
          Cancel
        </button>
        <button
          onClick={() => deleteUser()}
          disabled={deleteUserLoading}
          className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white rounded-xl font-medium transition-colors duration-200 flex items-center justify-center"
        >
          {deleteUserLoading ? <CircularProgress size="20px" /> : "Delete User"}
        </button>
      </div>
    </div>
  );
};
